import React, { useEffect } from "react";
import { CarReservation, VIEWED_CONTACT_MODAL } from "redmond";
import { ActionButton, ActionLink } from "halifax";
import { Box, Typography } from "@material-ui/core";
import { ChangeCarlModalContentConnectorProps } from "./container";
import * as constants from "./constants";
import dayjs from "dayjs";
import "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { trackEvent } from "../../../../../../../../api/v1/analytics/trackEvent";
import { getViewedCarContactModalProperties } from "../../../../../../reducer";
import { CONTACT_SUPPORT_URL } from "../../../../../../../../utils/paths";

export interface IChangeCarlModalContentProps
  extends ChangeCarlModalContentConnectorProps {
  car: CarReservation;
}

export const ChangeCarlModalContent = (props: IChangeCarlModalContentProps) => {
  const { setOpenModal, car } = props;
  const isAfter = dayjs().isAfter(dayjs(car.bookResult.pickUp.dateTime));

  useEffect(() => {
    if (car) {
      trackEvent({
        eventName: VIEWED_CONTACT_MODAL,
        properties: {
          ...getViewedCarContactModalProperties(car, "change_car"),
        },
      });
    }
  }, [car]);

  return (
    <Box className="change-car-modal-content">
      <Typography className="change-car-title" variant="h2">
        {constants.HEADING}
      </Typography>
      <Typography className="change-car-subtitle" variant="h5">
        {isAfter ? constants.SUBHEADING : constants.SUBHEADING_AGENT}
      </Typography>
      <Box className="change-car-buttons">
        {isAfter ? (
          <ActionLink
            className="provider-action"
            onClick={() => {
              window.open(CONTACT_SUPPORT_URL, "_blank", "noopener")?.focus();
            }}
            showTappableArea={true}
            content={
              <Typography variant="body2" className="check-in-link">
                {constants.PROVIDER_CTA}
                <FontAwesomeIcon
                  className="check-in-icon"
                  icon={faExternalLinkAlt}
                />
              </Typography>
            }
          />
        ) : (
          <ActionButton
            defaultStyle="h4r-primary"
            message={constants.CONTACT_SUPPORT}
            onClick={() => {
              window.open(CONTACT_SUPPORT_URL, "_blank", "noopener")?.focus();
            }}
          />
        )}
        <ActionButton
          defaultStyle={"h4r-secondary"}
          message={constants.CANCEL}
          onClick={() => setOpenModal({ type: null, selectedItinerary: null })}
        />
      </Box>
    </Box>
  );
};
